export class GalleryTagsFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getGalleryTags(filter) {
    return this.instance.get('/v1/gallery-tags', {
      params: filter || null,
    });
  }

  addGalleryTag(data) {
    return this.instance.post('/v1/gallery-tags', data);
  }

  editGalleryTag(id, data) {
    return this.instance.put(`/v1/gallery-tags/${id}`, data);
  }

  deleteGalleryTag(id) {
    return this.instance.delete(`/v1/gallery-tags/${id}`);
  }
}

export default (...params) => new GalleryTagsFactory(...params);

